import useShops from '@activities/shops/ShopListActivity/components/ShopList/hooks/useShops';
import ShopApi from '@apis/shop/ShopApi';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { itemActions } from '@store/item/itemSlice';
import { RootState } from '@store/store';
import { useDispatch, useSelector } from 'react-redux';

const TestActivity : ActivityComponentType = () => {
  const state = useSelector((state: RootState) => state.item);
  const dispatch = useDispatch();
  const { shops } = useShops({
    locationAgreed: false, ready: true,
  });
  return (
        <AppScreen>
            {shops.map((shop) => (
                <div key={shop.id}>
                    {shop.name}
                </div>
            ))}
            <br/>
            {JSON.stringify(state)}
        </AppScreen>
  );
};

export default TestActivity;
